<template>
  <div class="integralUser seller-style">
    <h2 class="f18 lin-25 fb normal gray_2">商品答疑</h2>
    <div class="box30"></div>
    <div>
      <div class="flex items-center justify-between">
        <div class="flex flex1 items-center">
          <el-input class="w210 mar20_r" placeholder="请输入商品名称关键字" v-model.trim="searchForm.spuNameLike"></el-input>
          <el-button type="primary" @click="searchList">查询</el-button>
          <el-button @click="restList">重置</el-button>
        </div>
        <div>
          <el-button type="primary" @click="toDetail('')">新增</el-button>
        </div>
      </div>
      <div class="box30"></div>
      <el-table border :data="list" @selection-change="goodsDySelect" row-class-name="pointer">
        <el-table-column type="selection" :reserve-selection="true" width="55"> </el-table-column>
        <el-table-column prop="name" label="商品名称" min-width="30%" />
        <el-table-column prop="detailAmount" label="答疑数量" min-width="15%" />
        <el-table-column label="操作" width="290">
          <template slot-scope="scope">
            <el-button @click="toDetail(scope.row.id)">编辑</el-button>
            <el-button type="primary" @click="delItem(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="bottom-handle-box">
        <el-button type="primary" class="mar-20-l" @click="batchDel()">删除</el-button>
      </div>
      <div class="flex items-center mar40-t">
        <div class="gray9 flex-auto">共 {{ total }} 条记录 第 {{ current }} / {{ pages }} 页</div>
        <el-pagination
          layout="prev, pager, next, sizes, jumper"
          background
          hide-on-single-page
          :page-size.sync="size"
          :page-count="pages"
          :current-page.sync="current"
          :page-sizes="[10, 50, 100]"
          @size-change="sizeChange"
          @current-change="currentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      env: process.env,
      searchForm: {
        id: "",
        name: "",
        status: "",
        spuNameLike: "",
      },
      list: [],

      size: 10,
      current: 1,
      pages: 1,
      total: 1,

      shareVisible: false,
      shareLoading: false,
      shareInfo: {},

      shippingType: 1,
      multipleSelection: [],
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  created() {
    this.getList();
    this.getShopSetting();
  },
  methods: {
    getShopSetting() {
      this.$store.dispatch("shop/shop/queryShopDtlByBoId").then((res) => {
        // shippingType：店铺支持的配送类型:1-卖家配送,2-买家自提,3:-都支持
        if (res.data) {
          const { shopDtlEntity } = res.data;
          this.shippingType = shopDtlEntity.shippingType;
        }
      });
    },
    getList() {
      const { size, current, searchForm } = this;
      this.$store
        .dispatch("goodsDy/getCommonActivity", {
          ...searchForm,
          size: size,
          current: current,
          type: "DY",
        })
        .then((data) => {
          const { records, pages, total } = data;
          console.log(data);
          this.list = records.map((item) => {
            return {
              ...item,
              shareLoading: false,
            };
          });
          this.pages = pages;
          this.total = total;
        });
    },

    // 搜索
    searchList() {
      this.current = 1;
      this.getList();
    },
    restList() {
      this.searchForm = {
        id: "",
        name: "",
        status: "",
      };
      this.current = 1;
      this.size = 10;
      this.getList();
    },
    // 修改每页显示个数
    sizeChange(size) {
      this.size = size;
      this.current = 1;
      this.getList();
    },

    // 修改页码
    currentChange(current) {
      this.current = current;
      this.getList();
    },

    goodsDySelect(val) {
      this.multipleSelection = val || [];
    },

    delItem(id) {
      const idList = [];
      idList.push(id);
      this.$confirm("您确认要删除选择商品答疑吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        this.$store
          .dispatch("goodsDy/delCommonActivity", {
            idList: idList,
          })
          .then((res) => {
            console.log(res);
            if (res.code === "0") {
              this.$message.success("删除成功！");
              this.getList();
            } else {
              this.$message.warning(res.msg);
            }
          });
      });
    },

    batchDel() {
      if (this.multipleSelection.length == 0) {
        this.$message.info("请选择");
        return;
      }
      const idList = [];
      this.multipleSelection.forEach(function (item) {
        idList.push(item.id);
      });
      this.$confirm("您确认要删除选择商品答疑吗?", "提示").then(() => {
        this.$store
          .dispatch("goodsDy/delCommonActivity", {
            idList: idList,
          })
          .then((res) => {
            if (res.code === "0") {
              this.$message.success("删除成功！");
              this.getList();
            } else {
              this.$message.warning(res.msg);
            }
          });
      });
    },

    toDetail(id) {
      const url = id ? `/mj/goodsDy/detail?id=${id}` : "/mj/goodsDy/detail";
      this.$router.push(url);
    },
  },
  // 监听器
  filters: {},
};
</script>

<style lang="scss" scoped>
@import "list.scss";
</style>
